import axios from "axios";
import { createClient } from "@supabase/supabase-js";
import { installApiErrorNormalizer } from "@/lib/apiError";

// Public pages (Events.jsx, Checkout.jsx, etc.) import the default `axios`
// export directly rather than a dedicated instance -- installing the
// normalizer on it here, once, at module load, covers every one of those
// call sites (and lib/auth.jsx's own plain axios.get for loadMe) the same way
// authAxios's own interceptor covers every admin call site.
installApiErrorNormalizer(axios);

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

export const supabase = supabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: "svj-tickets-auth",
      },
    })
  : null;

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
